// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html[dir] .rBWzkXIRiVApvI2w7wul{background-color:var(--flaggedMessage)}html[dir] .Ug5vjWyD6MccEzssj5iT{background-color:var(--themeLighterAlt)}html[dir] .fWXdQRYAE60H3JOjyiFH{background-color:var(--themeLighter)}html[dir] .fWXdQRYAE60H3JOjyiFH .J5CiDVtv0KbArHW9cbQc:hover{background:var(--themeLight)!important}html[dir] .U0KG5Gx0pOIzlE2J8Jbz{background-color:var(--themeLighterAlt)}html[dir] .UW2bej5t0coGDVhCF50V{background:var(--white)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flaggedMailListItemColor": "rBWzkXIRiVApvI2w7wul",
	"expandedMailListItemColor": "Ug5vjWyD6MccEzssj5iT",
	"selectedMailListItemColor": "fWXdQRYAE60H3JOjyiFH",
	"hoverActionIcon": "J5CiDVtv0KbArHW9cbQc",
	"pinnedMailListItemColor": "U0KG5Gx0pOIzlE2J8Jbz",
	"regularMailListItemColor": "UW2bej5t0coGDVhCF50V"
};
module.exports = ___CSS_LOADER_EXPORT___;
